<template>
  <div>
    <b-row class="mb-1" style="gap: 10px 0px">
      <b-col cols="12" md="2">
        <h4 class="font-weight-bold text-dark text-body mb-0 text-nowrap">
          Accounting Transactions
        </h4>
        <div class="d-flex" style="gap: 6px; flex-wrap: wrap; margin-top: 4px">
          <b-badge variant="dark">
            Cash Balance:
            <TokenBalances
              inline
              :balances="
                userData.dwalletBalance ? userData.dwalletBalance.balances : []
              "
              :fallback-amount="userData.user.balance || 0"
            />
          </b-badge>
          <b-badge variant="success">
            Bonus Balance:
            {{ formatCurrencyBuiltInFunc(availableBonus || 0) }}
          </b-badge>
        </div>
      </b-col>
      <!-- <b-col cols="6" md="2" class="text-right">
        <b-form-input
          v-model="filters.search"
          placeholder="Search transactions..."
          class="w-100"
        />
      </b-col> -->
      <b-col cols="4" md="2">
        <flat-pickr
          :value="filters.rangeTime"
          id="range-picker"
          class="form-control"
          :config="config"
          placeholder="From - To"
          @input="(val) => (this.filters.rangeTime = val)"
        />
      </b-col>
      <b-col cols="4" md="2">
        <v-select
          v-model="filters.type"
          :options="types"
          :clearable="false"
          class="w-100"
        />
      </b-col>
      <b-col cols="4" md="2">
        <v-select
          v-model="filters.transactionableType"
          :options="transactionableTypes"
          :clearable="false"
          class="w-100"
        />
      </b-col>
      <!-- <b-col cols="4" md="2">
        <v-select
          :value="filters.betID.label"
          :options="betIDs"
          :clearable="false"
          class="w-100"
        />
      </b-col> -->
      <!-- <b-col cols="4" md="2">
        <v-select
          :value="filters.transactionID.label"
          :options="transactionIDs"
          :clearable="false"
          class="w-100"
        />
      </b-col> -->
      <!-- <b-col cols="4" md="2">
        <v-select
          :value="filters.sortBy.label"
          :options="sortsBy"
          :clearable="false"
          class="w-100"
        />
      </b-col> -->

      <!-- <b-col cols="6" md="2">
        <b-button variant="success" class="w-100"> Add Transaction</b-button>
      </b-col> -->
    </b-row>
    <b-table
      :key="tableKey"
      :fields="fields"
      :items="fetchTransactions"
      responsive
      show-empty
      thead-class="text-nowrap"
    >
      <template #empty>
        <div v-if="loadingTrans" class="text-center text-dark my-2">
          <p>Loading... Please wait</p>
        </div>

        <div
          v-else-if="!loadingTrans && fetchTransactions.length === 0"
          class="text-center text-dark my-2"
        >
          No matching records found
        </div>
      </template>
      <template #cell(date)="{ item }">
        <span class="text-nowrap">{{
          format(new Date(item.date), "dd/MM/yyyy hh:mm:ss")
        }}</span>
      </template>
      <template #cell(createdBy)="{ item }">
        <span class="text-nowrap">{{ item.username }}</span>
      </template>
      <template #cell(transactionType)="{ item }">
        <span>{{ item.type }}</span>
      </template>
      <template #cell(amount)="{ item }">
        <span>{{
          item.amount ? formatCurrencyBuiltInFunc(item.amount) : "N/A"
        }}</span>
      </template>
      <template #cell(bonusCash)="{ item }">
        <span>{{
          item.bonus ? formatCurrencyBuiltInFunc(item.bonus) : "N/A"
        }}</span>
      </template>
      <template #cell(currentBalance)="{ item }">
        <span>{{
         formatCurrencyBuiltInFunc((item.amount || 0) + ( item.oldBalance || 0) )
        }}</span>
      </template>
      <template #cell(description)="{ item }">
        <span class="text-nowrap">{{ item.description }}</span>
      </template>
    </b-table>
    <div class="mx-2 mb-2" v-if="paginationTrans.total > 0">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            {{ paginationSummary }}
          </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="page"
            :total-rows="paginationTrans.total"
            :per-page="paginationTrans.limit"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #first-text
              ><span class="text-success">First</span></template
            >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
            <template #last-text><span class="text-info">Last</span></template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import {
  BCard,
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BFormCheckbox,
  BInputGroupAppend,
  BFormSelect,
  BFormTextarea,
  BBadge,
  BInputGroup,
  BTable,
  BCardBody,
  BLink,
  BPagination,
  BDropdown,
  BDropdownItemButton,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { debounce } from "debounce";
import vSelect from "vue-select";
import { format } from "date-fns";
import TokenBalances from "@/views/apps/customers/components/TokenBalances.vue";

export default {
  components: {
    TokenBalances,
    BCard,
    BCardBody,
    BButton,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BFormSelect,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    BRow,
    BBadge,
    BTable,
    BLink,
    BPagination,
    flatPickr,
    vSelect,
    BDropdown,
    BDropdownItemButton,
  },
  data() {
    const transactionableTypes = [
      {
        label: "Transaction Type",
        value: null,
      },
      {
        label: "Wallet",
        value: "Wallet",
      },
      {
        label: "Betslip",
        value: "Betslip",
      },
      {
        label: "Bonus Offer",
        value: "BonusOffer",
      },
      {
        label: "Withdrawal",
        value: "Withdrawal",
      },
    ];
    const types = [
      { label: "All Types", value: null },
      { label: "Adjustment", value: "adjustment" },
      { label: "Bet Entry", value: "bet-placed" },
      { label: "Place Bulk Betslip", value: "place-bulk-betslip" },
      { label: "Bet Refund", value: "bet-refund" },
      { label: "Bet Win", value: "bet-win" },
      { label: "Bet Win Cancelled", value: "bet-win-cancelled" },
      { label: "Bet Loss", value: "bet-loss" },
      { label: "Bet Delta Payout", value: "bet-delta-payout" },
      { label: "Cancel Bet Delta Payout", value: "cancel-bet-delta-payout" },
      { label: "Bet Partial Refund", value: "bet-partial-refund" },
      { label: "Bonus Bet Win", value: "bonus-bet-win" },
      { label: "Bonus Bet Win Cancelled", value: "bonus-bet-win-cancelled" },
      { label: "Cancel Bets", value: "cancel-bets" },
      { label: "Money Back", value: "bonus-bet-win" },
      { label: "Revert Money Back", value: "bonus-bet-win-cancelled" },
      { label: "Deposit", value: "deposit" },
      { label: "Fee", value: "fee" },
      { label: "Free Bet Refund", value: "free-bet-refund" },
      { label: "Free Bet Partial Refund", value: "free-bet-partial-refund" },
      { label: "Manual Adjustment", value: "manual-adjustment" },
      { label: "Promo", value: "promo" },
      { label: "Remove Expired Bonus", value: "remove-expired-bonus" },
      { label: "Update Bonus", value: "update-bonus" },
      {
        label: "Adjust Reverse Transaction",
        value: "adjust-reverse-transaction",
      },
      { label: "Withdrawal", value: "withdrawal" },
      { label: "Withdrawal Cancelled", value: "withdrawal-cancelled" },
    ];

    const betIDs = [
      {
        label: "Bet ID",
        value: null,
      },
    ];
    const transactionIDs = [
      {
        label: "Transaction ID",
        value: null,
      },
    ];
    const sortsBy = [{ label: "Sort By", value: null }];

    return {
      filters: {
        type: types[0],
        transactionableType: transactionableTypes[0],
        betID: betIDs[0],
        transactionID: transactionIDs[0],
        sortBy: sortsBy[0],
        search: "",
        rangeTime: "",
      },
      tableKey: 0,
      types,
      transactionableTypes,
      betIDs,
      transactionIDs,
      sortsBy,
      page: 1,
      fields: [
        { key: "date", label: "Transaction Date" },
        { key: "id", label: "Transaction ID" },
        { key: "createdBy", label: "Created By" },
        // { key: "externalRef", label: "External Ref." },
        { key: "name", label: "Processor Name" },
        { key: "transactionableType", label: "Transaction Type" },
        { key: "amount", label: "Amount" },
        { key: "bonusCash", label: "Bonus Cash" },
        { key: "currentBalance", label: "Current Cash Balance" },
        { key: "description", label: "Notes" },
      ],
      config: {
        mode: "range",
        altFormat: "d-m-Y",
        altInput: true,
      },
    };
  },
  computed: {
    ...mapState("user/detail", {
      loadingTrans: "loadingTrans",
      transactions: "transactions",
      paginationTrans: "paginationTrans",
      userData: "userData",
    }),
    ...mapState("user/bonus", ["availableBonus"]),
    paginationSummary() {
      const p = this.paginationTrans || {};
      const page = Number(p.page) || 1;
      const limit = Number(p.limit || p.perPage) || 10;
      const total = Number(p.total) || 0;

      const from = total === 0 ? 0 : (page - 1) * limit + 1;
      const to = total === 0 ? 0 : Math.min(page * limit, total);

      return total === 0
        ? `Showing 0 of 0 entries`
        : `Showing ${from} - ${to} of ${total} entries`;
    },
  },
  watch: {
    "filters.search"() {
      this.handleSearchDebounced();
    },
    page() {
      this.updateTableKey();
    },
    "filters.rangeTime"(newRange) {
      if (newRange) {
        const [startDate, endDate] = newRange.split(" to ") || [];
        if (startDate && endDate) this.updateTableKey();
      }
    },
    "filters.type"() {
      this.updateTableKey();
    },
    "filters.transactionableType"() {
      this.updateTableKey();
    },
    "$route.params.id": {
      handler: async function (newId) {
        await this.fetchTransactions();
      },
    },
  },
  mounted() {
    this.handleSearchDebounced = debounce(this.handleSearch, 300);
  },
  methods: {
    ...mapActions({
      getTransactionByUser: "user/detail/getTransactionByUser",
    }),
    format,
    formatCurrencyBuiltInFunc,
    async fetchTransactions() {
      if (this.loadingTrans) return;
      const { page, filters } = this;
      const params = {
        page,
        "excludeTypes[0]": "place-bulk-betslip",
        "excludeTypes[1]": "cancel-bets",
        "excludeTypes[2]": "manual-adjustment",
        "excludeTypes[3]": "update-bonus",
        "excludeTypes[4]": "bet-loss",
        "excludeTypes[5]": "cancel-bet-delta-payout",
        "excludeTypes[6]": "bet-delta-payout",
        userId: this.$router.currentRoute.params.id,
        ...(filters.search && { search: filters.search }),
        ...(filters.transactionableType.value && {
          transactionableType: filters.transactionableType.value,
        }),
        ...(filters.type.value && { type: filters.type.value }),
      };
      if (filters.rangeTime) {
        const [startDate, endDate] = filters.rangeTime.split("to ");
        if (startDate && endDate) {
          params["date[startDate]"] = startDate;
          params["date[endDate]"] = endDate;
        }
      }
      try {
        const data = await this.getTransactionByUser(params);
        return data;
      } catch (error) {
        return [];
      }
    },
    updateTableKey() {
      this.tableKey++;
    },
    handleSearch() {
      this.page = 1;
      this.updateTableKey();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
